import { render, staticRenderFns } from "./JournalEntries.vue?vue&type=template&id=1f22fd43&scoped=true"
import script from "./JournalEntries.vue?vue&type=script&lang=js"
export * from "./JournalEntries.vue?vue&type=script&lang=js"
import style0 from "./JournalEntries.vue?vue&type=style&index=0&id=1f22fd43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f22fd43",
  null
  
)

export default component.exports